import { createContext, useContext } from "react";
import type { ProjectOutletContext } from "./ProjectLayout";

const ProjectLayoutContext = createContext<ProjectOutletContext | null>(null);

/** Gives the whole project layout its context: the routed page, and the
 *  session sidebar that sits beside the outlet, where `useOutletContext` is
 *  empty. */
export const ProjectLayoutProvider = ProjectLayoutContext.Provider;

/** The open project, or null outside a project route. */
export const useProjectLayout = (): ProjectOutletContext | null => useContext(ProjectLayoutContext);
